import { FormUploadSummaryItem } from '@ui-components/form/FormUploadSummaryItem'
import { styled } from 'styled-components'

import { FileObject } from '../types'

interface FormUploadSummaryListProps {
  files: FileObject[]
  onItemClick: (fileId: string) => void
  itemAriaLabelPrefix: string
  allowDownload?: boolean
}

const UnorderedList = styled.ul`
  list-style-type: square;
  li {
    margin-top: 16px;
    margin-left: 24px;
  }
`

export const FormUploadSummaryList = ({
  files,
  itemAriaLabelPrefix,
  onItemClick,
  allowDownload = true,
}: FormUploadSummaryListProps) => {
  return (
    <UnorderedList id="attachment-summary" data-testid="attachment-summary">
      {files.map((file: FileObject) => (
        <FormUploadSummaryItem
          key={file.id}
          fileName={file.name}
          onClick={
            allowDownload
              ? () => {
                  if (file?.fileId && onItemClick) onItemClick(file.fileId)
                }
              : undefined
          }
          ariaLabel={allowDownload ? `${itemAriaLabelPrefix}${file.name}` : file.name}
        />
      ))}
    </UnorderedList>
  )
}
